import Sidebar from '@components/Sidebar';

/**
 * AppLayout — wraps all authenticated pages.
 * Sidebar on the left, page content on the right.
 * No top Navbar for authenticated users — Sidebar handles all navigation.
 *
 * Desktop sidebar is a floating glass rail (Sidebar.jsx) that overlays
 * content rather than reserving a column for itself. `main` here carries
 * NO left padding/offset — it must not, because it's the ancestor of
 * every page's own background-painting root element, and padding on an
 * ancestor pushes that background's box inward with it. That's what
 * produced the "glass has nothing behind it" bug: each page's background
 * div started at the rail's right edge instead of the viewport's, so the
 * glass sat over whatever this component's own background happened to
 * be (often a mismatched shade, or a solid light one when the page was
 * dark) rather than a continuation of the page itself.
 *
 * The rail-width offset (60px collapsed rail + 12px inset = 72px) now
 * lives on an INNER wrapper inside each page's own background element —
 * see PromptLanding/PromptSandbox/CopywritingLanding/
 * SalesNegotiationLanding/Dashboard/Skills/Settings/Feedback/Billing —
 * so the background spans full width underneath the rail while only the
 * actual content is inset from it.
 */
const AppLayout = ({ children }) => (
  <div className="flex min-h-screen bg-[#faf9f7] dark:bg-[#0e0d0c]">
    <Sidebar />
    {/* Skip link target (index.html) — tabIndex={-1} lets a
        non-focusable element like <main> actually receive focus when the
        skip link jumps here, without joining the normal tab order. */}
    <main
      id="main-content"
      tabIndex={-1}
      className="flex-1 min-w-0 overflow-x-hidden overflow-y-visible"
    >
      {/* Mobile: pad top so hamburger button doesn't overlap page title */}
      <div className="md:hidden" style={{ height: 52 }} />
      {children}
    </main>
  </div>
);

export default AppLayout;
